<template>
  <div>
    <div class="col form-group cep-step">
        <div class="section-row div-flex-row">
          <!-- Zip Code -->
          <input
            ref="cepInput"
            id="cep"
            v-model="obj.cep"
            :v-mask="masks"
            class="cep-field"
            :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
            :placeholder="translation.cep"
            type="text"
            @keyup="getCEP"
          />

          <!-- City -->
          <input
            ref="cepInput"
            v-model="obj.localidade"
            class="city-field"
            :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
            :placeholder="translation.cidade"
            :disabled="disableLocalidade"
            type="text"
          />
        </div>

        <div class="section-row">
          <!-- Address -->
          <input
            type="text"
            name=""
            v-model="obj.logradouro"
            :disabled="disableLogradouro"
            ref="cepInput"
            class="mt-4 w-100"
            :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
            :placeholder="translation.endereço"
          />

          <!-- Neighborhood -->
          <div class="section-row div-flex-row">
            <input
              v-if="!obj.passport"
              type="text"
              name=""
              v-model="obj.bairro"
              :disabled="disableBairro"
              ref="cepInput"
              class="mt-4 bairro"
              :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
              :placeholder="translation.neighborhood"
            />

            <!-- State (Foreign) -->
            <div v-if="obj.passport && !skipStateField" class="mt-4 d-flex flex-column w-100">
              <input
                type="text"
                name=""
                v-model="obj.uf"
                :disabled="disableBairro"
                ref="cepInput"
                :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
                :placeholder="translation.estado"
                maxlength="4"
              />
              <small class="text-muted mt-2">{{ translation.estadoHint }}</small>
            </div>

            <!-- State (Brazil) -->
            <select
              v-if="!obj.passport && !skipStateField"
              v-model="obj.uf"
              :disabled="disableUf"
              ref="ufInput"
              class="uf mt-4"
              :class="template.secondaryTheme ? 'secondary-input-theme' : 'c-input'"
            >
              <option
                :style="
                  template.secondaryTheme ? 'color:black !important' : 'color:black !important'
                "
                value=""
                disabled
                hidden
              >
                Escolha o Estado
              </option>

              <option
                :style="
                  template.secondaryTheme ? 'color:black !important' : 'color:black !important'
                "
                v-for="estado in estados"
                :key="estado.sigla"
                :value="estado.sigla"
              >
                {{ estado.sigla }}
              </option>
            </select>
          </div>
        </div>
    </div>

    <div class="col form-group">
      <div class="section-row div-flex-row">
        <!-- Number -->
        <input
          type="text"
          name=""
          v-model="obj.numero"
          ref="cepInput"
          class="numero"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="translation.number"
        />

        <!-- Complement -->
        <input
          type="text"
          name=""
          v-model="obj.complement"
          ref="cepInput"
          class="complemento"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="translation.complemento"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

/* Helpers */
import { mask } from 'vue-the-mask'

/* Services */
import axios from 'axios'

export default {
  name: 'Cep',
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  props: {
    validate: Boolean,
  },
  data: () => ({
    obj: {
      uf: null,
    },
    estados: [],
    disableLocalidade: false,
    disableLogradouro: false,
    disableBairro: false,
    disableUf: false,
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'template', 'registrationObject', 'subdomain']),
    masks() {
      if (this.obj.passport) {
        return []
      }
      return ['#####-###', '#####-###']
    },
    skipStateField() {
      const steps = this.config.registrationSteps || []
      return String(this.config.iso3 || '').toUpperCase() === 'FRA' && steps.includes('Cep')
    },
    translation() {
      return {
        attention: this.$t('common.attention'),
        cep: this.$t('cep.cep'),
        cidade: this.$t('cep.city'),
        endereço: this.$t('cep.address'),
        complemento: this.$t('cep.complement'),
        estado: this.$t('cep.state'),
        estadoHint: this.$t('cep.stateHint'),
        neighborhood: this.$t('cep.neighborhood'),
        number: this.$t('cep.number'),
        msgError: {
          cep: this.$t('cep.cepRequired'),
          number: this.$t('cep.numberRequired'),
          onlyNumber: this.$t('cep.onlyNumber'),
          address: this.$t('cep.addressRequired'),
          neighborhood: this.$t('cep.neighborhoodRequired'),
          state: this.$t('cep.stateRequired'),
        },
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
    document.getElementById('cep').focus()
    if (!this.obj.passport && !this.skipStateField) {
      this.getState()
    }
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    getState() {
      const url = `${process.env.VUE_APP_FANPAGEDOMAIN}/api/identity/ufs/`
      axios.get(url).then(response => {
        this.estados = response.data.data
        if (this.estados.length > 0 && !this.obj.uf) {
          this.obj.uf = this.estados[0].sigla
        }
      })
    },
    handleDisableInputs() {
      if (this.obj.localidade) {
        this.disableLocalidade = true
      }
      if (this.obj.logradouro) {
        this.disableLogradouro = true
      }
      if (this.obj.bairro) {
        this.disableBairro = true
      }
      if (this.obj.uf) {
        this.disableUf = true
      }
    },
    getCEP() {
      if (!this.obj.passport) {
        let ceptext = this.obj.cep.replace('-', '')

        if (ceptext.length == 8) {
          const urlViaCep = `https://viacep.com.br/ws/${ceptext}/json/`
          const urlFanpageApi = `${process.env.VUE_APP_FANPAGEDOMAIN}/api/identity/zipCode/${ceptext}`

          axios.get(urlViaCep).then(
            response => {
              let dados = response.data
              this.obj = dados
              this.handleDisableInputs()
            },
            error => {
              if (this.obj.livesInBrazil === false) {
                return alert(error)
              } else {
                axios.get(urlFanpageApi).then(
                  response => {
                    let dados = response.data.data
                    this.obj = dados
                    this.handleDisableInputs()
                  },
                  err => {
                    return alert(err)
                  },
                )
              }
            },
          )
        }
      }
    },
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.translation.attention,
        variant: variant,
        solid: true,
      })
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.obj.cep) {
        this.addRegistrationError({
          msg: this.translation.msgError.cep,
        })
        this.toastMessage = this.translation.msgError.cep
        this.makeToast('warning')

        hasErrors = true
      }

      if (!this.obj.numero) {
        this.addRegistrationError({
          msg: this.translation.msgError.number,
        })
        this.toastMessage = this.translation.msgError.number
        this.makeToast('warning')

        hasErrors = true
      } else if (!/^\d+$/.test(this.obj.numero)) {
        this.addRegistrationError({
          msg: this.translation.msgError.onlyNumber,
        })
        this.toastMessage = this.translation.msgError.onlyNumber
        this.makeToast('warning')

        hasErrors = true
      }

      if (!this.obj.bairro && !this.obj.passport) {
        this.addRegistrationError({
          msg: this.translation.msgError.neighborhood,
        })
        this.toastMessage = this.translation.msgError.neighborhood
        this.makeToast('warning')

        hasErrors = true
      }

      if (!this.obj.localidade || !this.obj.logradouro) {
        this.addRegistrationError({
          msg: this.translation.msgError.address,
        })
        this.toastMessage = this.translation.msgError.address
        this.makeToast('warning')

        hasErrors = true
      }

      if (!this.skipStateField && !this.obj.uf) {
        this.addRegistrationError({
          msg: this.translation.msgError.state,
        })
        this.toastMessage = this.translation.msgError.state
        this.makeToast('warning')

        hasErrors = true
      }

      if (!hasErrors) {
        if (this.skipStateField) {
          this.obj.uf = 'SP'
        }
        this.$store.commit('updateRegistrationObject', this.obj)
        this.$emit('next')
      }
    },
  },
}
</script>

<style scoped>
.cep-step {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;
}

.section-row {
  position: relative;
  z-index: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.div-flex-row {
  display: flex;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.div-flex-row > input,
.div-flex-row > select,
.div-flex-row > input.c-input,
.div-flex-row > input.secondary-input-theme,
.div-flex-row > select.c-input {
  min-width: 0;
  width: auto !important;
  max-width: 100%;
  box-sizing: border-box;
}

.cep-field {
  flex: 3 1 0;
}

.city-field {
  flex: 7 1 0;
}

.bairro {
  flex: 3 1 0;
}

.uf {
  color: white !important;
  flex: 1 1 0;
  position: relative;
  padding: 8px 0;
  z-index: 1;
}

.numero {
  flex: 1 1 0;
}

.complemento {
  flex: 3 1 0;
}

.estado option {
  color: black;
  background-color: white;
  line-height: inherit;
}

@media (max-width: 499px) {
  .div-flex-row > input,
  .div-flex-row > select {
    font-size: 0.95rem;
  }
}
</style>
